module.exports = __webpack_public_path__ + "static/media/sarcoptesDrawn.a5617859.jpg";